// Leaf import (not the core/i18n barrel, which pulls i18n.config -> common/utils
// and would cycle). toLocaleDateString needs BCP-47 tags; i18n.language arrives
// as underscore codes (en_US/de_DE/fr_FR) and would otherwise throw RangeError.
import { toBcp47 } from 'core/i18n/language.utils';
import { isValidNumber } from './math.utils';

export const isValidDate = (d: Date): boolean => isValidNumber(d?.getTime?.());

export const defaultFormatDate = (date: Date, language: string) =>
  date.toLocaleDateString(toBcp47(language), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
